import { PaymentCard } from '@mews/framework';
import { getSourceImageByType } from './helpers';
import { PaymentMethodImageStyled } from './style';
import { PaymentMethodImageTypeProps } from './types';

export const PaymentMethodImage: React.FC<PaymentMethodImageTypeProps> = ({ assetLoader, className, type, small }) => {
    const folder = PaymentCard.isValidImageCardType(type) ? 'creditCards' : 'paymentMethods';

    return assetLoader?.isInitialized ? (
        <PaymentMethodImageStyled
            className={className}
            src={assetLoader.getAssetSrc(`${folder}/${getSourceImageByType(type)}`)}
            small={small}
        />
    ) : null;
};
